import * as React from 'react'
import { PasswordInput, TextInput, required } from 'react-admin'
import { TwoColumnInput } from 'shared/molecules/TwoColumnInput'

import mailjetLogo from './mailjet.svg'

const Inputs = (props) => (
  <>
    <TwoColumnInput title="API Key" description="Mailjet API Key">
      <TextInput {...props} source="config.api_key" label="API Key" validate={[required()]} />
    </TwoColumnInput>
    <TwoColumnInput title="API Secret" description="Mailjet API Secret">
      <PasswordInput {...props} source="config.api_secret" label="API Secret" validate={[required()]} />
    </TwoColumnInput>
    <TwoColumnInput title="List ID" description="Contact list ID">
      <TextInput {...props} source="config.list_id" label="List ID" validate={[required()]} />
    </TwoColumnInput>
    <TwoColumnInput title="Contact Properties" description="Contact properties (comma delimited)">
      <TextInput {...props} source="config.properties" label="Contact Properties" />
    </TwoColumnInput>
  </>
)

// https://iconify.design/icon-sets/mdi/slack.html
export default class MailjetChannelType {
  static Name = 'Mailjet'
  static Icon = mailjetLogo
  static Inputs = Inputs
  static summaryFor(channel) {
    return `Mailjet list (ID ${channel.config.list_id}) subscription`
  }
}
